import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Button } from './ui/button';

export const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-pink-50">
      {/* Header */}
      <div className="bg-white shadow-sm sticky top-0 z-10">
        <div className="container mx-auto px-6 py-4">
          <Button
            onClick={() => window.location.href = '/'}
            variant="ghost"
            className="text-[#eb068c] hover:text-[#c7056f]"
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            Voltar para Home
          </Button>
        </div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-6 py-12 max-w-4xl">
        <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
          Termos de Uso
        </h1>
        <p className="text-gray-600 mb-8">
          Última atualização: {new Date().toLocaleDateString('pt-BR')}
        </p>

        <div className="bg-white rounded-xl shadow-sm p-8 space-y-8">
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Aceitação dos Termos</h2>
            <p className="text-gray-700 leading-relaxed">
              Ao acessar e usar o site da <strong>Plantinha de Geladeira</strong>, você concorda em cumprir 
              e estar vinculado a estes Termos de Uso. Se você não concorda com qualquer parte destes termos, 
              não utilize nosso site ou serviços.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Serviços B2B</h2>
            <p className="text-gray-700 leading-relaxed mb-3">
              A Plantinha de Geladeira oferece soluções B2B de plantas magnéticas personalizadas para:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
              <li>Brindes corporativos e eventos empresariais</li>
              <li>Presentes para colaboradores e clientes</li>
              <li>Compras em grandes volumes para revenda autorizada</li>
            </ul>
            <p className="text-gray-700 leading-relaxed mt-3">
              Todos os pedidos B2B estão sujeitos a aprovação, negociação de condições comerciais 
              e disponibilidade de estoque.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Pedidos e Orçamentos</h2>
            <p className="text-gray-700 leading-relaxed">
              Os orçamentos fornecidos têm validade limitada e podem ser alterados sem aviso prévio. 
              Os pedidos são confirmados apenas após:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4 mt-3">
              <li>Aprovação do orçamento por escrito</li>
              <li>Confirmação de pagamento ou condições acordadas</li>
              <li>Validação de especificações técnicas e personalização</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Preços e Pagamento</h2>
            <p className="text-gray-700 leading-relaxed">
              Os preços apresentados são para referência e podem variar conforme volume, personalização 
              e condições comerciais negociadas. Formas de pagamento aceitas incluem:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4 mt-3">
              <li>Transferência bancária</li>
              <li>Boleto bancário</li>
              <li>Pagamento parcelado (sujeito a aprovação de crédito)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Entrega e Prazos</h2>
            <p className="text-gray-700 leading-relaxed">
              Os prazos de entrega são estimados e podem variar conforme a complexidade do pedido, 
              localização e disponibilidade. Nos comprometemos a:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4 mt-3">
              <li>Informar prazos realistas no momento da confirmação do pedido</li>
              <li>Comunicar qualquer atraso significativo com antecedência</li>
              <li>Garantir embalagem adequada para transporte seguro</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Propriedade Intelectual</h2>
            <p className="text-gray-700 leading-relaxed">
              Todo o conteúdo deste site (textos, imagens, logotipos, design) é propriedade da 
              Plantinha de Geladeira e está protegido por leis de direitos autorais. É proibido:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4 mt-3">
              <li>Copiar, reproduzir ou distribuir conteúdo sem autorização prévia</li>
              <li>Usar imagens de produtos para fins comerciais não autorizados</li>
              <li>Reproduzir designs personalizados criados para outros clientes</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Garantia e Devoluções</h2>
            <p className="text-gray-700 leading-relaxed">
              Garantimos a qualidade de nossos produtos. Em caso de defeito de fabricação ou produto 
              em desacordo com o pedido:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4 mt-3">
              <li>Entre em contato em até 7 dias após o recebimento</li>
              <li>Envie fotos que comprovem o problema</li>
              <li>Realizaremos a troca ou reembolso conforme o caso</li>
            </ul>
            <p className="text-gray-700 leading-relaxed mt-3">
              <strong>Atenção:</strong> Produtos personalizados não são passíveis de devolução, 
              exceto em casos de defeito comprovado.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Limitação de Responsabilidade</h2>
            <p className="text-gray-700 leading-relaxed">
              A Plantinha de Geladeira não se responsabiliza por:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4 mt-3">
              <li>Danos indiretos ou consequenciais do uso de nossos produtos</li>
              <li>Atrasos causados por transportadoras ou eventos de força maior</li>
              <li>Problemas decorrentes de uso inadequado dos produtos</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Privacidade</h2>
            <p className="text-gray-700 leading-relaxed">
              O uso de informações pessoais é regido por nossa{' '}
              <a href="/politica-privacidade" className="text-[#eb068c] hover:underline font-medium">
                Política de Privacidade
              </a>
              . Recomendamos sua leitura atenta.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Alterações nos Termos</h2>
            <p className="text-gray-700 leading-relaxed">
              Reservamo-nos o direito de modificar estes Termos de Uso a qualquer momento. 
              As alterações entram em vigor imediatamente após a publicação no site. 
              O uso contínuo do site após as alterações constitui aceitação dos novos termos.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">11. Lei Aplicável e Foro</h2>
            <p className="text-gray-700 leading-relaxed">
              Estes Termos de Uso são regidos pelas leis da República Federativa do Brasil. 
              Fica eleito o foro da comarca de São Paulo/SP para dirimir quaisquer controvérsias 
              decorrentes destes termos.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">12. Contato</h2>
            <p className="text-gray-700 leading-relaxed">
              Para dúvidas sobre estes Termos de Uso ou questões comerciais:
            </p>
            <div className="mt-4 p-4 bg-pink-50 rounded-lg">
              <p className="text-gray-700"><strong>E-mail:</strong> b2b@plantinhadegeladeira.com.br</p>
              <p className="text-gray-700"><strong>WhatsApp:</strong> (11) 94165-1849</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};
